import React, { useRef, useState, useEffect } from 'react';

const CodeInput = ({
  onChange,
  onSubmit,
  isError,
}) => {
  const [codeValue, setCodeValue] = useState(Array(6).fill(''));
  const inputRefs = Array(6).fill().map(() => useRef());

  useEffect(() => {
    onChange(codeValue.join(''));
  }, [codeValue]);

  const isDigit = ch => ch.charCodeAt(0) >= 48 && ch.charCodeAt(0) <= 57;
  const validateCodeValue = code => /^\d{6}$/.test(code);
  const moveCaretLeft = index => {
    if (index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };
  const moveCaretRight = index => {
    if (index < 5) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleChange = ({ currentTarget }) => {
    const index = Number(currentTarget.id);
    if (isDigit(currentTarget.value)) {
      const newCodeValue = [...codeValue];
      newCodeValue[index] = currentTarget.value;
      setCodeValue(newCodeValue);
      moveCaretRight(index);
    }
  };

  const handleKeyDown = (event) => {
    const { currentTarget } = event;
    const index = Number(currentTarget.id);
    if (event.keyCode === 8) {
      // Backspace
      if (currentTarget.value) {
        const newCodeValue = [...codeValue];
        newCodeValue[index] = '';
        setCodeValue(newCodeValue);
      }
      moveCaretLeft(index);
    } else if (event.keyCode === 13) {
      // Enter
      if (validateCodeValue(codeValue.join(''))) {
        onSubmit && onSubmit();
      }
    } else if (event.keyCode === 37) {
      // Left arrow
      moveCaretLeft(index);
    } else if (event.keyCode === 39) {
      // Right arrow
      moveCaretRight(index);
    } else if (event.keyCode >= 48 && event.keyCode <= 57) {
      // Digit
      const newCodeValue = [...codeValue];
      newCodeValue[index] = '';
      setCodeValue(newCodeValue);
    }
  };

  const handlePaste = (event) => {
    const code = event.clipboardData.getData('Text');
    if ([...code].find(c => !isDigit(c))) return;
    setCodeValue([...code]);
    event.preventDefault();
  };

  return <div className="code_input__container">
    {inputRefs.map((_, i) => {
      return <input
        autoFocus={i === 0}
        autoComplete="off"
        id={i}
        key={i}
        maxLength="1"
        className={`code_input__input_field ${!codeValue[i] && 'code_input__input_field_empty' || ''} ${isError && 'code_input__input_error' || ''}`}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        ref={inputRefs[i]}
        value={codeValue[i] || ''}
        type="tel"
      />
    })}
  </div>;
};

export default CodeInput;